import script from "./BannerColorBg.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerColorBg.vue?vue&type=script&setup=true&lang=js"

import "./BannerColorBg.vue?vue&type=style&index=0&id=78ad07c0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ad07c0"]])

export default __exports__